









































































import ButtonSendEmail from "./ButtonSendEmail.vue";
import _ from "lodash";
import assert from "assert";
import { Column, Election, Voter, Vue } from "@/types.ts";
import { VueGoodTable } from "vue-good-table";

export default Vue.extend({
  components: {
    ButtonSendEmail,
    Vuetable: VueGoodTable,
  },
  computed: {
    columnsVoters(): Array<Column> {
      if (this.voters) return this.columnsOfVoters(this.voters);
      else return [];
    },
    editableSuper(): boolean {
      assert(this.election);
      return !this.election.published && this.superuser;
    },
    voters(): Array<Voter> | null {
      const election = this.election;
      if (!election) return null;
      return election.voters;
    },
    votersExport(): string | null {
      if (!this.voters) return null;
      const blob = new Blob(
        [
          "sep=,\n",
          "Nom,Courriel,Voix,Emargement\n",
          ..._.map(this.voters, (voter: Voter) => {
            return `${voter.name},${voter.email},${voter.votes},${
              voter.time ? this.formatTime(voter.time) : ""
            }\n`;
          }),
        ],
        { type: "text/csv" }
      );
      return window.URL.createObjectURL(blob);
    },
  },
  methods: {
    columnsOfVoters(voters: Array<Voter>) {
      const columns: Array<Column> = [
        {
          label: "Nom",
          field: "name",
        },
        {
          label: "Courriel",
          field: "email",
        },
        {
          label: "Votes",
          field: "votes",
          type: "number",
        },
      ];
      if (_.find(voters, voter => voter.code) !== undefined)
        columns.push({ label: "Code", field: "code" });
      if (_.find(voters, voter => voter.data) !== undefined)
        columns.push({ label: "Donnée Personnelle", field: "data" });
      if (_.find(voters, voter => voter.phone) !== undefined)
        columns.push({ label: "Téléphone", field: "phone" });
      if (this.election?.published) {
        columns.push({
          label: "Émargement",
          field: "time",
          sortable: false,
        });
        if (this.superuser) {
          columns.push({
            label: "Envoyer",
            field: "send-email",
            sortable: false,
          });
        }
      }
      return columns;
    },
    exportContactList() {
      this.$store.dispatch("exportContactList", { election: this.election });
    },
    formatTime(date: Date) {
      return `${date.toLocaleDateString("fr-FR")} ${date.toLocaleTimeString(
        "fr-FR"
      )}`;
    },
    push() {
      this.$emit("push");
    },
    sendEmails() {
      this.$store.dispatch("sendEmail", { election: this.election });
    },
  },
  props: {
    election: { type: Object as () => Election, required: true },
    editable: { type: Boolean, default: false },
    superuser: { type: Boolean, default: false },
  },
});
